import { ChangeSocial } from 'commands/business/social/ChangeSocial';

export class ChangeInstagram extends ChangeSocial {
  type: string = 'ChangeInstagram';
}
